import { render } from "./ViewPricingRule.vue?vue&type=template&id=ca13f3bc&scoped=true&ts=true"
import script from "./ViewPricingRule.vue?vue&type=script&lang=ts"
export * from "./ViewPricingRule.vue?vue&type=script&lang=ts"

import "./ViewPricingRule.vue?vue&type=style&index=0&id=ca13f3bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca13f3bc"]])

export default __exports__